/**
 * DrillBreadcrumbs — the drill trail (site → month → order → line), lifted
 * from fast-cortex MarginAnalysisView: each path crumb is a button; clicking
 * crumb i pops the path to slice(0, i+1), so the view rises to the level just
 * below that crumb. The terminal element names the current level (not a
 * button — you are already there). Typed props only (CD-7).
 */

import React from 'react'
import { ChevronRight } from 'lucide-react'
import type { PathSegment } from '../../types/metrics'

interface DrillBreadcrumbsProps {
  path: PathSegment[]
  levelLabel: string // display name(s) of the CURRENT level
  onNavigate: (path: PathSegment[]) => void
}

export default function DrillBreadcrumbs({
  path,
  levelLabel,
  onNavigate,
}: DrillBreadcrumbsProps): React.JSX.Element {
  return (
    <nav aria-label="Drill path" className="flex flex-wrap items-center gap-0.5 text-xs">
      {path.map((segment, index) => (
        <React.Fragment key={`${segment.level}:${segment.id}`}>
          <button
            type="button"
            onClick={() => onNavigate(path.slice(0, index + 1))}
            title={`Back to ${segment.level.replace(/_/g, ' ')} ${segment.id}`}
            className="cx-btn rounded-lg border border-line bg-panel px-2.5 py-1 font-medium text-mut hover:text-brand"
          >
            {segment.id}
          </button>
          <ChevronRight size={12} className="text-mut2" />
        </React.Fragment>
      ))}
      <span className="rounded-lg border border-brand bg-info-bg px-2.5 py-1 font-semibold text-brand">
        {levelLabel}
      </span>
    </nav>
  )
}
